/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useState, useCallback } from 'react';
import { Button } from '@pwc/pwc-deals-ui';
import { AutoCreateComponentProps } from '@pwc/auto-save-ui';
import AutoCreate, { ContentType } from 'common/components/AutoCreate';
import { POTopicServiceHttpClient } from 'common/services/httpClient';
import classNames from 'classnames';
import { AutoCreateTopicProps, Content } from './types';
import ContentLoader from './ContentLoader';
import styles from './AutoCreateTopic.module.scss';

/**
 * The purpose of this component is to consume the AutoCreate component and return the newly created content to the parent component when successful
 * @param param0 // an object that contains projectId, temporaray Id of the topic that will be created, and the onSave callback which will save topic to the list
 * @returns // returns newly created content if auto create is successful otherwise, it returns a React fragment because there is nothing to render
 */
const AutoCreateTopic = ({
  projectId,
  id,
  onSave,
  onError,
  onCancel,
}: AutoCreateTopicProps) => {
  const [hasFailed, setHasFailed] = useState(false);

  const handleOnSave = useCallback(
    (content: Content) => {
      const { contentThreadId, title } = content;
      onSave(id, contentThreadId, {
        content: {
          title,
        },
      });
    },
    [id, onSave]
  );

  const handleOnError = useCallback(() => {
    setHasFailed(true);
    onError(id);
  }, [id, onError]);

  const handleOnCancel = useCallback(() => onCancel(id), [id, onCancel]);

  return (
    <div className="project-overview-module">
      <AutoCreate
        contentType={ContentType.POTopic}
        createApiEndpointUrl={`/projects/${projectId}/topics`}
        httpClient={POTopicServiceHttpClient}
        errorClasses={styles.error}
        loaderClasses={styles['loader-wrapper']}
      >
        {({
          isSuccess,
          isError,
          content,
        }: AutoCreateComponentProps<Content>) => {
          if (isSuccess) {
            return <ContentLoader onLoad={handleOnSave} {...content} />;
          }

          if (isError) {
            return <ContentLoader onLoad={handleOnError} {...content} />;
          }

          return <></>;
        }}
      </AutoCreate>
      <div className="topic-footer">
        <div className="separator" />
        <div className="topic-footer__buttons">
          {hasFailed && (
            <Button
              data-testid="topic-cancel-button"
              type="button"
              onClick={handleOnCancel}
              className={classNames(
                'ui-button button-link form-cancel-button',
                styles.cancelButton
              )}
              disabled={!hasFailed}
              icon={undefined}
              iconClasses={undefined}
            >
              Cancel
            </Button>
          )}
          <Button
            data-testid="topic-edit-button"
            type="button"
            className="ui-button button-small"
            disabled
            icon={undefined}
            iconClasses={undefined}
          >
            Done
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AutoCreateTopic;
